export default __webpack_public_path__ + "static/media/bulding.78519be9.gif";